import { CategoriesDocument } from '~/graphql/operations'
import { BaseSelect } from '../model'

export class CategorySelect extends BaseSelect {
  override name = 'category'
  override label = 'Category'
  override defaultTextPriority?: boolean = true
  override placeholder = 'Select category'
  override filterResults = false

  constructor(args: any) {
    super(args)
  }

  mapData(payload) {
    const data = payload?.categories.data?.map((category) => ({
      ...category,
      defaultText: {
        name: category.breadcrumbs.join(' > '),
      },
    }))
    return {
      categories: {
        data,
      },
    }
  }

  override async options(query?: string, where: any = {}) {
    const { useDefaultChannel, textChannel, ...rest } = where
    let channelId = undefined

    // Handle channelId properly
    if (where.channelId) {
      if (typeof where.channelId === 'object') {
        // If it's already an object with equals, use it as is
        channelId = where.channelId
      } else if (typeof where.channelId === 'number') {
        // If it's a number, format it as an IntFilterInput object
        channelId = {
          equals: parseInt(where.channelId, 10),
        }
      }
    }

    // Default channel fallback
    if (!channelId && useDefaultChannel) {
      channelId = {
        equals: 1,
      }
    }

    const trimmed = (query ?? '').trim()
    const asId = /^\d+$/.test(trimmed) ? Number(trimmed) : null

    return this.optionsQuery(CategoriesDocument, 'categories', {
      variables: {
        channel: textChannel || undefined,
        where: {
          ...rest,
          channelId,
          id: asId != null ? { equals: asId } : undefined,
          categoryTexts:
            asId == null && query
              ? {
                  some: {
                    name: {
                      contains: query || undefined,
                    },
                  },
                }
              : undefined,
        },
        perPage: 100,
      },
      mapData: this.mapData,
    })
  }

  override async initialOptions(ids: any[], where: any = {}) {
    const { useDefaultChannel, textChannel, ...rest } = where

    // Handle channelId properly for initialOptions too
    let channelId = undefined
    if (where.channelId) {
      if (typeof where.channelId === 'object') {
        channelId = where.channelId
      } else if (typeof where.channelId === 'number') {
        channelId = {
          equals: parseInt(where.channelId, 10),
        }
      }
    }

    // Default channel fallback
    if (!channelId && useDefaultChannel) {
      channelId = {
        equals: 1,
      }
    }

    const hasIds = !!ids?.length

    return this.optionsQuery(CategoriesDocument, 'categories', {
      variables: {
        where: {
          id: hasIds
            ? {
                in: ids.map(Number),
              }
            : undefined,
          ...rest,
          // Already saved assignments must always resolve to a label, even if
          // the category belongs to another channel than the one the picker is
          // currently filtered by. Otherwise the select treats the value as
          // unknown and flushes it from the form.
          channelId: hasIds ? undefined : channelId,
        },
        channel: textChannel || undefined,
        perPage: 100,
      },
      mapData: this.mapData,
    })
  }
}
